var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"question-type-badge"},[(_vm.icon)?_c('img',{staticClass:"badge-icon",attrs:{"src":_vm.icon,"alt":""}}):_vm._e(),_vm._v(_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }